export enum ServiceType {
    InvoiceCapture = 'ic',
    DocumentCapture = 'dc',
}

export function getCaption(serviceType: ServiceType) {
    switch (serviceType) {
        case ServiceType.InvoiceCapture:
            return 'Invoice Capture';
        case ServiceType.DocumentCapture:
            return 'Document Capture';
    }
}

export function fullName(serviceType: ServiceType) {
    switch (serviceType) {
        case ServiceType.InvoiceCapture:
            return 'invoices';
        case ServiceType.DocumentCapture:
            return 'documents';
        default:
            return 'unknown';
    }
}
